import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[paceCoreTextInputRestriction]',
})
export class TextInputRestrictionDirective {
    public constructor(private el: ElementRef) {}

    @HostListener('keydown', ['$event'])
    public onKeyDown(event: KeyboardEvent): void {
        const nativeEl = <HTMLInputElement>this.el.nativeElement;
        if (nativeEl.selectionStart === 0 && event.code === 'Space') {
            event.preventDefault();
        }
    }
}
